"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightWidgetDescriptionTrigger = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var util_1 = require("@gooddata/util");
var DescriptionClickTrigger_1 = require("./DescriptionClickTrigger");
var model_1 = require("./../../../model");
exports.InsightWidgetDescriptionTrigger = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var widget = props.widget, insight = props.insight;
    var visible = (_c = (_b = (_a = widget.configuration) === null || _a === void 0 ? void 0 : _a.description) === null || _b === void 0 ? void 0 : _b.visible) !== null && _c !== void 0 ? _c : true;
    var description = ((_e = (_d = widget.configuration) === null || _d === void 0 ? void 0 : _d.description) === null || _e === void 0 ? void 0 : _e.source) === "widget" ? widget.description : insight.insight.summary;
    var trimmedDescription = description === null || description === void 0 ? void 0 : description.trim();
    var widgetRefAsString = sdk_model_1.objRefToString(sdk_model_1.widgetRef(widget));
    var userInteraction = model_1.useDashboardUserInteraction();
    var eventPayload = {
        from: "widget",
        type: ((_g = (_f = widget.configuration) === null || _f === void 0 ? void 0 : _f.description) === null || _g === void 0 ? void 0 : _g.source) === "widget" ? "custom" : "inherit",
        description: trimmedDescription,
    };
    if (visible && trimmedDescription && trimmedDescription !== "") {
        return (react_1.default.createElement(DescriptionClickTrigger_1.DescriptionClickTrigger, { className: "widget-description-" + util_1.stringUtils.simplifyText(widgetRefAsString), description: trimmedDescription, onOpen: function () { return userInteraction.descriptionTooltipOpened(eventPayload); } }));
    }
    return null;
};
//# sourceMappingURL=InsightWidgetDescriptionTrigger.js.map